import { parseColor, rgbToHex } from './colorUtils'

/**
 * Function calculates HSP to determine whether color is light or dark
 */
const lightOrDark = (col) => {
  const rgb = parseColor(col)
  if (!rgb) return 'dark'
  
  const { r, g, b } = rgb

  // HSP equation from http://alienryderflex.com/hsp.html
  const hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

  // Using the HSP value, determine whether the color is light or dark
  if (hsp > 127.5) {
    return "light";
  }
  if (hsp <= 127.5 && hsp > 20) {
    return "dark";
  }
  return "darker";
};

/**
 * Function converts hex to RGB and lightens/darkens each r g b value
 */
const shadeColor = (col, amt) => {
  const rgb = parseColor(col)
  if (!rgb) return col
  
  let { r: R, g: G, b: B } = rgb

  // to make the colour less bright than the input
  // change the following three "+" symbols to "-"
  R += amt;
  G += amt;
  B += amt;

  if (R > 255) R = 255;
  else if (R < 0) R = 0;

  if (G > 255) G = 255;
  else if (G < 0) G = 0;

  if (B > 255) B = 255;
  else if (B < 0) B = 0;

  return rgbToHex(R, G, B)
};

export const hoverColor = (color) => {
  if (!color) return '';
  const colorLevel = lightOrDark(color);
  if (colorLevel === "light") {
    return shadeColor(color, -18);
  }
  if (colorLevel === "dark") {
    return shadeColor(color, 18);
  }
  return shadeColor(color, 28);
};